module.exports = __webpack_public_path__ + "static/media/Team 19 - UNI-ty.96acac5b.png";